import { pipe } from 'fp-ts/function';

import * as A from 'fp-ts/Array';
import * as R from 'fp-ts/Record';

/**
 * Given an object with boolean values, get a list of the
 * keys whose values are `true`
 *
 * @example
 *   getSelectedKeys({a: true, b: false, c: true})
 *   // ['a', 'c']
 */
export const getSelectedKeys = (obj: Record<string, boolean>) =>
  pipe(
    obj,
    R.keys,
    A.filter((key) => obj[key]),
  );
